import { createRouter, createWebHistory } from 'vue-router'
import { api } from '@/core/api'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // Public routes
    {
      path: '/',
      name: 'landing',
      component: () => import('@/pages/LandingPage.vue'),
      meta: { layout: 'public' },
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('@/pages/PricingPage.vue'),
      meta: { layout: 'public' },
    },
    {
      path: '/terms-and-conditions',
      name: 'terms',
      component: () => import('@/pages/TermsPage.vue'),
      meta: { layout: 'public' },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/pages/PrivacyPage.vue'),
      meta: { layout: 'public' },
    },
    {
      path: '/refund',
      name: 'refund',
      component: () => import('@/pages/RefundPage.vue'),
      meta: { layout: 'public' },
    },

    // Auth callbacks (no layout — minimal page)
    {
      path: '/auth/callback',
      name: 'authCallback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { layout: 'none' },
    },
    {
      path: '/auth/github/callback',
      name: 'authGithubCallback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { layout: 'none' },
    },
    {
      path: '/auth/gitlab/callback',
      name: 'authGitlabCallback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { layout: 'none' },
    },

    // Protected routes (default = app layout)
    {
      path: '/projects',
      name: 'projects',
      component: () => import('@/pages/ProjectsPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/create',
      name: 'createProject',
      component: () => import('@/pages/CreateProjectPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/project/:id',
      name: 'board',
      component: () => import('@/pages/BoardPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/pages/SettingsPage.vue'),
      meta: { requiresAuth: true },
    },

    // 404 catch-all
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: () => import('@/pages/NotFoundPage.vue'),
      meta: { layout: 'public' },
    },
  ],
})

// Navigation guard
router.beforeEach(async (to, _from) => {
  const isAuthenticated = api.isAuthenticated()

  // Redirect unauthenticated users from protected routes
  if (to.meta.requiresAuth && !isAuthenticated) {
    return '/'
  }

  // When authenticated, ensure user profile is loaded (survives page refresh)
  if (isAuthenticated) {
    const authStore = useAuthStore()
    if (!authStore.user && !authStore.loading) {
      try {
        await authStore.fetchProfile()
      } catch {
        // Token may be expired — redirect to landing
        api.setToken(null)
        return '/'
      }
    }
  }

  // Redirect authenticated users from landing to projects
  if (to.path === '/' && isAuthenticated) {
    return '/projects'
  }

  return true
})

export default router
